module.exports = __webpack_public_path__ + "static/media/gallery-kelso.79d216ee.jpg";